import React, { Component } from 'react';
import {Header} from './header.js';
import {defaultHeaders, handleErrors} from './util.js'
import UserSelect from './user-select.js'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import 'react-tabs/style/react-tabs.css'
import './manage.css';
import downArrow from './resource/downArrow.png';

export class ManagePage extends Component {
    constructor(props) {
        super(props);
        const userName = JSON.parse(localStorage.getItem('user')).username;
        this.state = { userName: userName, allUsers: [] };
        this.userSelectFrom = React.createRef();
        this.userSelectTo = React.createRef();
        this.userSelectToggleActive = React.createRef();
    }

    componentDidMount() {
        var self = this;
        fetch('/api/get-users', { headers: defaultHeaders() })
            .then( handleErrors )
            .then( response => response.json() )
            .then( data => { self.setState({ allUsers: data }); } )
            .catch( error => console.log( error ) );
    }

    showFeedback = response => {
        response.json()
        .then( json => {
          let msg = "Erledigt, betroffene Produkte:\n" + JSON.stringify( json );
          alert( msg );
        })
    }

    handleTransfer = () => {
        const fromRef = this.userSelectFrom.current;
        const toRef = this.userSelectTo.current;

        const fromId = fromRef.state.row;
        const toId = toRef.state.row;

        if (! (fromId || toId) )
            alert( "Leere Auswahl (von, zu)" );
        else if (! toId)
            alert( "Leere Auswahl (zu)" );
        else if (! fromId)
            alert( "Leere Auswahl (von)" );
        else {
            let msg = "Produkte zuweisen von Nutzer " + fromId + " zu Nutzer " + toId + "?";
            if (window.confirm(msg)) {
                let headers = defaultHeaders();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');
                fetch('/api/transfer-products', {
                    method: 'POST',
                    headers: headers,
                    body: `from=${fromId}&to=${toId}`
                })
                    .then( handleErrors )
                    .then( this.showFeedback )
                    .catch( error => console.log( error ) );
            }
        }
    }

    handleToggleActive = (flag) => {
        const userRef = this.userSelectToggleActive.current;
        const toggleId = userRef.state.row;

        if( ! toggleId )
          alert( "Leere Auswahl" );
        else {
          let msg = "Produkte von Nutzer " + toggleId + (flag ? " aktivieren": " deaktivieren") + "?";
          if (window.confirm(msg)) {
             let headers = defaultHeaders();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');
                fetch('/api/toggle-products-active', {
                    method: 'POST',
                    headers: headers,
                    body: `for-user=${toggleId}${flag? "&flag=T":""}`
                })
                    .then( handleErrors )
                    .then( this.showFeedback )
                    .catch( error => console.log( error ) );
            }
        }
    }

    render() {
        return (
                <div className="Landing" id="contentId">
                <Header username={ this.props.username } propagateLogin={ this.props.propagateLogin } />
                <div className="ContentWithBackground">

                <Tabs>

                <TabList>
                  <Tab>Produkte zuweisen</Tab>
                  <Tab>Produkte (de)aktivieren</Tab>
                </TabList>

                <TabPanel>
                <UserSelect users={ this.state.allUsers } caption="VON" ref={ this.userSelectFrom } />

                <img src={ downArrow } alt="down arrow" />
                <img src={ downArrow } alt="down arrow" />

                <UserSelect users={ this.state.allUsers } caption="ZU" ref={ this.userSelectTo } />

                <button onClick={ this.handleTransfer }>Produkte zuweisen</button>
                </TabPanel>

                <TabPanel>
                <UserSelect users={ this.state.allUsers } caption="Nutzer" ref={ this.userSelectToggleActive } />

                <button onClick={ () => this.handleToggleActive(false) }>Produkte deaktivieren</button>
                <button onClick={ () => this.handleToggleActive(true) }>Produkte aktivieren</button>
                </TabPanel>
                </Tabs>

                </div>
                </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/manage.js